import {DataObject} from "./DataObject";

export class FacilityInvoice implements DataObject {
  ID: number;
  printNode_ID: number;
  network_ID: number;
  fromOrganizationType: string;  // enum: ["FACILITY", "ORGANIZATION", "SERVICEPROVIDER", "AGENT", "NETWORK"],
  toOrganizationType: string; //    enum: ["FACILITY", "ORGANIZATION", "SERVICEPROVIDER", "AGENT", "NETWORK"],
  periodType: string; // enum: ["DAY", "WEEK", "MONTH", "QUARTER", "YEAR"],
  periodStart: Date;
  periodEnd: Date;
  invoiceNumber: number;
  lastOrderDate: Date;
  generatedDate: Date;
  submittedDate: Date;
  noteToCustomer: string | null;
  status: string; // enum: ["INITIAL", "PREPARING", "FINALIZED", "HELD", "SENT", "PAID", "CONTESTED"],
  paymentMethod: string | null;
  lastUpdate: Date | null;
  dueDate: Date;
  invoiceDate: Date | null;
  emailSentTo: string;
  currency: string;
  amount: number;
  recurring: string;
  contestStatus: string; // enum: ["RESOLVED", "ADJUSTED", "UNCONTESTED", "CONTESTED"],

  constructor ( obj ) {
    if ( obj && obj['ID']) {
      this.ID = obj['ID'];
    }
    this.update(obj);
  }

  public getId() {
        return this.ID;
  }

  public getOrderValue() {
      return this.ID;
  }

  update (obj: any) {
    if (obj) {
      for (const prop of Object.keys(obj)) {
        if (obj[prop] !== null && (prop !== 'ID') && ( typeof obj[prop] === 'string' || typeof obj[prop] === 'number' || typeof obj[prop] === 'boolean' || obj[prop] instanceof String || obj[prop] instanceof Boolean || obj[prop] instanceof Number || obj[prop] instanceof Date )) {
          this[prop] = obj[prop];
        }
      }
    }
  }
}

